import { Common } from "@common/types";
import { isUndefined } from "lodash";
import * as React from "react";
import { ModalCloseButton, ModalHeaderButton, type ModalHeaderButtonProps } from "./Buttons";

export type HeaderRenderProps = {
  onCloseClick?: () => void;
};

export interface HeaderProps {
  action?: ModalHeaderButtonProps;
  isCloseButtonHidden?: boolean;
  isEnlarged?: boolean;
  isPinned?: boolean;
  title?: any;
  addon?: React.JSX.Element;
  onBackClick?: () => void;
  onCloseClick?: () => void;
  onToggleEnlarged?: () => void;
  onTogglePinned?: () => void;

  children?: (props: HeaderRenderProps) => React.ReactNode;
}

const HeaderBase = (props: HeaderProps) => (
  <div className="modal-header">
    {props.children ? (
      props.children({ onCloseClick: props.onCloseClick })
    ) : (
      <>
        <h4 className="modal-title single-line-ellipsis">
          {props.onBackClick && (
            <ModalHeaderButton className="back" onClick={props.onBackClick} icon={Common.IconType.ArrowLeft} />
          )}
          {typeof props.title === "string" ? (
            <span className="title" dangerouslySetInnerHTML={{ __html: props.title }} />
          ) : (
            <span className="title">{props.title}</span>
          )}
        </h4>
        <div className="addon">{props.addon}</div>

        <div className="buttons">
          {!isUndefined(props.isEnlarged) && (
            <ModalHeaderButton
              onClick={props.onToggleEnlarged}
              icon={
                props.isEnlarged
                  ? Common.IconType.ArrowDownLeftAndArrowUpRightToCenter
                  : Common.IconType.ArrowsLeftRight
              }
              style={props.isEnlarged ? { transform: "rotate(45deg)" } : undefined}
            />
          )}

          {!isUndefined(props.isPinned) && (
            <ModalHeaderButton
              onClick={props.onTogglePinned}
              icon={props.isPinned ? Common.IconType.ArrowUpLeft : Common.IconType.ArrowDownRight}
            />
          )}

          {props.action && <ModalHeaderButton {...props.action} />}

          {!props.isCloseButtonHidden && <ModalCloseButton onClick={props.onCloseClick!} />}
        </div>
      </>
    )}
  </div>
);
const Header = React.memo(HeaderBase);
export default Header;
